var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"TkfI192tT_GYE1346D4dg"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["vinicum-giv-next@webranking-srl"]={id:"TkfI192tT_GYE1346D4dg"};
      